import { useState, useEffect } from "react";
import useRequest from "./useRequest";
import {
  PlacesAutoCompleteQuery,
  PlacesSearchQueryResponse,
} from "../types/cities";

export function useGooglePlacesApi(params: PlacesAutoCompleteQuery) {
  const [lastQuery, setLastQuery] = useState(params.input);
  const [fetchParams, setFetchParams] =
    useState<PlacesAutoCompleteQuery | null>(null);

  const { data, error, isValidating, isLoading, mutate } = useRequest<
    any,
    PlacesSearchQueryResponse
  >(
    fetchParams
      ? {
          url: "https://places.googleapis.com/v1/places:searchText",
          method: "POST",
          data: { textQuery: fetchParams.input },
          headers: {
            "Content-Type": "application/json",
            "X-Goog-Api-Key": fetchParams.key,
            "X-Goog-FieldMask":
              "places.displayName,places.formattedAddress,places.location,places.id,places.iconMaskBaseUri,places.iconBackgroundColor",
          },
        }
      : null, // Do not call the API if fetchParams is null
    {
      // Optional: you can adjust the dedupingInterval or other options here
    }
  );

  useEffect(() => {
    if (params.input !== lastQuery) {
      setLastQuery(params.input);
      setFetchParams(params); // Trigger the API call by updating fetchParams
    }
  }, [params.input, lastQuery, data]);

  const reformData = (data: any) => {
    const results =
      data && data?.places
        ? data?.places?.map((place: any) => ({
            formatted_address: place?.formattedAddress,
            geometry: {
              location: {
                lat: place?.location?.latitude,
                lng: place?.location?.longitude,
              },
            },
            icon: place?.iconMaskBaseUri + ".png",
            name: place?.displayName?.text,
            place_id: place?.id,
            iconBg: place?.iconBackgroundColor,
          }))
        : [];
    return {
      results,
    };
  };

  return {
    data: reformData(data),
    error,
    isValidating,
    isLoading,
    mutate,
    places: data?.places?.map((place: any) => place?.formattedAddress) ?? [],
    dataClone: reformData(data),
  };
}
